import styles from "./styles.module.scss";

export function Footer() {
  return (
    <footer className={styles.FooterContainer}>
      <p>Feito por Welisson Henrique</p>
    </footer>
  );
}
